export interface ChevronDownIconProps {
  height?: number;
  width?: number;
  className?: string;
}

const ChevronDownIcon = ({
  height = 20,
  width = 20,
  className,
}: ChevronDownIconProps) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16 7L10.2827 12.7168C10.2077 12.7918 10.106 12.834 10 12.834C9.89396 12.834 9.79226 12.7918 9.71733 12.7168L4 7"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ChevronDownIcon;
